import { render, staticRenderFns } from "./administrationMenu.vue?vue&type=template&id=2c9bafd8&scoped=true&"
import script from "./administrationMenu.vue?vue&type=script&lang=js&"
export * from "./administrationMenu.vue?vue&type=script&lang=js&"
import style0 from "./administrationMenu.vue?vue&type=style&index=0&id=2c9bafd8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9bafd8",
  null
  
)

export default component.exports